<template>
    <div v-if="confirmOtpStage == false" class="page bg-blue relative desktop-footer">
        <div class="bg-head-coin hidden sm:block"></div>
        <div class="page-content sm:px-4">
            <TopBar class="hidden sm:block" title="Home" :isShowOnlyLogo="true" :modalController="modalController"></TopBar>
            <TopBarBack class="block sm:hidden"></TopBarBack>
            <MenuDesktop activeMenu="home"></MenuDesktop>
            <div class="bg-white mt-4 p-5 sm:rounded-25">
                <PathLink></PathLink>
                <FormEditProfile
                    v-if="form"
                    :form="form"
                    ref="form-profile"
                    :controller="modalController">
                </FormEditProfile>
                <div class="text-center pt-6">
                    <Submitbtn @click="onSubmitData()"> {{lbl.profile.save}} </Submitbtn>
                </div>
                <img class="w-165px m-auto pt-3" src="@/assets/logo/power-tip.png">
            </div>
        </div>
        <Bottombar></Bottombar>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>

    <!-- * ShowOtp Stage on cahnge contactnumber -->
    <div  v-if="confirmOtpStage == true">
        <verifyOtp
            :modalController="modalController"
            :dataVerify="otpRegisterForm"
            @callApiVerifyMember="callApiVerifyMember($event)">
        </verifyOtp>

        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>

<script>
import TopBar from '@/components/Layout/TopBar/TopBar.vue';
import MenuDesktop from '@/components/Layout/MenuDesktop/MenuDesktop.vue';
import PathLink from '../component/PathLink.vue';
import FormEditProfile from '../component/FormEditProfile.vue';
import Submitbtn from "@/module/Register/component/SubmitBtn.vue";
import TopBarBack from '@/components/Layout/TopBar/TopBarBack.vue';
import Bottombar from '@/components/Layout/BottomBar/BottomBar.vue'
import verifyOtp from '@/module/Register/verifyUser/components/verifyOtp.vue';
//mixin
import AuthStatusMixin from "@/mixin/AuthStatusMixin";
import ModalMixin from '@/mixin/ModalMixin';
import { RegisterModel , ValidateForm } from '@/core/Account/model/RegisterModel';
//service
import BzbsEditProfileService from '../service/BzbsEditProfileService.js'
import LocaleMixin from '@/mixin/LocaleMixin';
// import BzbsRegister from "../service/BzbsRegister.js"

export default {
    name: 'EditProfile',
    mixins: [ModalMixin,AuthStatusMixin, LocaleMixin],
    components: {
        TopBar,
        MenuDesktop,
        PathLink,
        FormEditProfile,
        Submitbtn,
        TopBarBack,
        Bottombar,
        verifyOtp
    },
    data: function() {
        return {
            form: null,

            old_contact_number: null,
            confirmOtpStage: false,
            otpRegisterForm: null,
        };
    },

    mounted() {

    },
    created: function(){

    },
    methods: {
         // ModalMixin
         onSetupModalCompleted: function() {
            this.initialOtpModal();
        },

        onAccountInit: async function() {
            if (this.isLogin) {
                this.modalController.loadingModal.show();
                console.log('profile :' ,this.profile);
                this.form = await new RegisterModel().getDataProfileFromApi(this.profile);
                console.log(this.form)
                // Save contact Number
                this.old_contact_number = this.form.contact_number;

                this.modalController.loadingModal.hide();
            }else{
                this.modalController.alertModal
                    .setMsg(this.lbl.home.login.please_login)
                    .show();
            }
        },
        onSubmitData: async function(){
            let isValidatePass = this.$refs['form-profile'].validateRegisterForm()
            let checkFormatPassword = new ValidateForm().checkFormatPassword(this.form)
            if(!isValidatePass.pass){
                this.modalController.alertModal
                    .clearModal()
                    .setMsg(isValidatePass.msg)
                    .show();
            }else if(!checkFormatPassword){
                this.modalController.alertModal
                    .setMsg(this.lbl.profile.password_desc)
                    .show();
            }else{
                this.modalController.confirmModal
                    .clearModal()
                    .setMsg(this.lbl.profile.confirm_edit2)
                    .setTitle(this.lbl.profile.confirm_edit)
                    .setBtnOk(this.lbl.profile.confirm)
                    .show();
                this.modalController.confirmModal.onClickOk(() => {
                    this.submitDataApi();
                });
            }
        },
        submitDataApi: async function(){
            this.modalController.loadingModal.show();
            let params = await new RegisterModel().getParamsRegister(this.form);
            // Check Contact Number Change
            if(this.checkContactNumberChange(params) == true){
                return ; // ! countinue on otp page stage
            }
            //  Normal Flow
            else{
                return new Promise((resolve) => {
                    BzbsEditProfileService.updateProfile(params).subscribe({
                        next: (res) => {
                            this.modalController.loadingModal.hide();
                            this.showSuccessModal();
                            resolve(res);
                        },
                        error: (err) => {
                            console.log(err)
                            this.modalController.loadingModal.hide();
                            this.modalController.alertModal
                                .setMsg(this.lbl.profile.save_not_success)
                                .show();
                            resolve(null);
                        }
                    })
                })
            }
        },
        checkContactNumberChange:function(currentFormData){
            // Check contactNumber Has been change
            if(this.old_contact_number != null &&currentFormData.contact_number != this.old_contact_number){
                this.otpRegisterForm = currentFormData;
                this.otpRegisterForm.mobile = currentFormData.contact_number;
                this.confirmOtpStage = true;

                return true;
            }
            return false;
        },
        callApiVerifyMember: async function (data) {
            this.modalController.loadingModal.show();
            this.confirmOtpStage = false;

            let params = await new RegisterModel().getParamsRegister(this.form);
            params.otp = data.otp;
            params.refcode = data.refcode;

            return new Promise((resolve) => {
                BzbsEditProfileService.updateProfile(params).subscribe({
                    next: (res) => {
                        this.modalController.loadingModal.hide();
                        this.showSuccessModal();
                        resolve(res);
                    },
                    error: (err) => {
                        console.log(err)
                        this.modalController.loadingModal.hide();
                        this.modalController.alertModal
                            .setMsg(this.lbl.profile.save_not_success)
                            .show();
                        resolve(null);
                    }
                })
            })
        },

        showSuccessModal: function(){
            this.modalController.successModal
                .setTitle(this.lbl.profile.save_success)
                .setMsg(this.lbl.profile.save_success2)
                .show();
            this.modalController.successModal.onClickOk(() => {
                window.location.href = '/home'
            });
        }
    },
};
</script>

<style lang="scss" scoped>

</style>
